export default "__VITE_ASSET__CpNgkVby__"